export const colors = {
  orange: {
    orioles_orange: "#FA4A0C",
  },
  white: {
    one: "#FFFFFF",
    anti_flash_white: "#F2F2F2",
  },
  yellow: {
    maize: "#F2C94C",
  },
  black: {
    black: "#000000",
    dark_charcoal: "#333333",
  },
  gray: {
    one: "#B8B8BB",
    two: "#BDBDBD",
    spanish_gray: "#9D9D9A",
  },
  background: "#F7F7F7",
};
